import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { MiViewFontSize } from 'miview-ui/miviewTheme';

export const menuItemStyle: SxProps<Theme> = {
  fontSize: MiViewFontSize.medium,
  fontFamily: 'Roboto',
};

export const iconStyle: SxProps<Theme> = {
  width: '24px',
  height: '24px',
  marginLeft: '4px',
};

export const menuItemElementStyle: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
};
